INTERSTITIAL_REMOVE